/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import { useRef,useState } from 'react'
import CustomDatePicker from '../../../components/DatePicker'
import dayjs from 'dayjs'
import OrganizationDropdownCorpWithSearch from './dropdownWithSearchForOrg'

export default function FilterBtn({dateError,setdateError,isFilterOpen,setIsFilterOpen,handleApplyFilter,isFilterOrganization,initialState,filterValues,setFilterValues,handleOpenFilter,selectedOrganizationName,setSelectedOrganizationName,setSubDivisionDataLoading,subDivisionDataLoading,userArr,isPatientSearch}) {

    const handleCheck=()=>{
        if((dayjs(filterValues?.end_date).isBefore(dayjs(filterValues?.start_date)))&&(filterValues?.end_date!==undefined&&filterValues.start_date!==undefined)){
            return true
        }
        return false
    }

    return (
        <div className='xl:relative ml-2.5'>
            <button id='filter' type='button' className='flex items-center border border-[#972E4C] rounded-[15px] px-4 py-2 min-w-max' onClick={handleOpenFilter}>
                <img src="/images/filter_icon.svg" alt="icon" />
                <span className='text-lg font-semibold text-[#972E4C] ml-2.5'>Filter</span>
            </button>
            {
                isFilterOpen && 
               
                    <div  className=' absolute top-14 right-0 left-auto bg-white rounded-[15px] border border-[#D296B2] px-2.5 pt-4 py-[26px] shadow-s2 w-[430px] z-[99]'>
                        <div className='flex justify-between items-center mb-4'>
                            <p className='text-sm font-semibold text-[#52555D]'>Filter by:</p>
                            {dateError &&<p className="text-xs text-red-500 mt-2 mr-8">Please select the valid date range.</p>}
                            <button type='button' onClick={()=>{setIsFilterOpen(!isFilterOpen),setdateError(false)}}>
                                <img src="/images/cross_mark_gray.svg" alt="icon" />
                            </button>
                        </div>
                        <div className='flex flex-wrap -mx-2'>
                            <div className={`${isPatientSearch===undefined?'w-1/2':'w-full'} px-2 mb-4`}>
                                <div className="w-full">
                                    <OrganizationDropdownCorpWithSearch
                                        label={"Patient Name"}
                                        id={`patient_name`}
                                        placeholder={'Select patient name'}
                                        disabled={false}
                                        setSubDivisionDataLoading={setSubDivisionDataLoading}
                                        selectedOrganizationName={selectedOrganizationName}
                                        setSelectedOrganizationName={setSelectedOrganizationName}
                                        selectOrgName={selectedOrganizationName[0]?.patient_id ? `${selectedOrganizationName[0]?.patient_id} ${selectedOrganizationName[0]?.patient_name}` : ""}
                                        setFilterValues={setFilterValues}
                                        index={0}
                                        // adminCorpLink={true}
                                        optionId={"option_organization_name"}
                                        isObserver={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex mt-[13px] justify-between">
                            <button  onClick={()=>{handleApplyFilter(false),setdateError(false),setFilterValues(initialState),setIsFilterOpen(false)}}
                                id="Cancel"
                                className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-lg font-semibold text-[#972E4C] mr-[38px]" 
                            >Clear All</button>
                            <button  
                                onClick={()=>{
                                    if(handleCheck())
                                    {setdateError(true) 
                                        return}
                                    handleApplyFilter(true),setIsFilterOpen(false)}}
                                type='button'
                                id="apply-filter"
                                disabled={Object.values(filterValues).every(value => typeof value === 'string' && value.trim() === '')} 
                                className={`py-2.5 w-[106px] px-4 rounded-[16px]  ${Object.values(filterValues).every(value => typeof value === 'string' && value.trim() === ''||value===undefined)?'bg-[#777C88]':'bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] border border-[#972E4C]'}   text-lg font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                                Apply
                            </button>
                        </div>
                    </div>
                // </motion.div>
            }
        </div>  
    )
}
